<template>
    <div class="filter-section fifth-filter-section-mobile">
        <div class="filter-group">
            <h4 class="filter-group-title">Configuración de la cartera</h4>
        </div>
        <div class="pair-container fifth-inputs-container-mobile">
            <div class="input-wrapper account_value-container">
                <label for="filters-fifth-mobile-account-value" class="input-label">Capital Real €</label>
                <input
                    id="filters-fifth-mobile-account-value"
                    type="number"
                    min="0"
                    class="vanilla-input number-input"
                    :value="finder.account_value"
                    :placeholder="placeholder_account"
                    @input="saveAccountValue($event.target.value)"
                />
            </div>
            <div class="input-wrapper risk-container">
                <label for="filters-fifth-mobile-risk" class="input-label">Riesgo %</label>
                <input
                    id="filters-fifth-mobile-risk"
                    type="number"
                    min="0"
                    class="vanilla-input number-input"
                    :value="finder.risk"
                    :placeholder="placeholder_risk"
                    @input="saveRisk($event.target.value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
    export default {
        name: 'Fifth',
        data: () => ({
            finder: {
                account_value: 0,
                risk: 0,
            },
            placeholder_account: "",
            placeholder_risk: "",
        }),
        created(){
            this._syncFinder(this._g_FinderFilters);
        },
        watch: {
            _g_FinderFilters: {
                handler(newFinder) {
                    this._syncFinder(newFinder);
                },
                deep: true,
            },
        },
        computed: {
            ...mapGetters(['_g_FinderFilters']),
        },
        methods: {
            ...mapMutations(['setFinderFilters']),
            _syncFinder(newFinder) {
                if (!newFinder || typeof newFinder !== 'object') {
                    return;
                }
                this.finder = JSON.parse(JSON.stringify(newFinder));
                this.placeholder_account = (this.finder.account_value ?? 0).toString();
                this.placeholder_risk = (this.finder.risk ?? 0).toString();
            },

            _updateLastSearch2: function(){
                this.setFinderFilters(this.finder);
                this.$emit("updateLastSearch", this.finder);
            },  

            saveAccountValue: function(value) {
                const res = value === "" ? 0 : value;
                this.finder["account_value"] = parseInt(res, 10) || 0;
                this._updateLastSearch2();
            },

            saveRisk: function(value) {
                const res = value === "" ? 0 : value;
                this.finder["risk"] = parseInt(res, 10) || 0;
                this._updateLastSearch2();
            },
        }
    }
</script>

<style scoped>
    .fifth-inputs-container-mobile{
        display: flex;
        gap: 10px; 
        margin-top: 8px;
        flex-wrap: wrap;
    }

    .account_value-container,
    .risk-container{
        min-width: 150px;
        width: 100%;
    }
</style>
